module.exports = __webpack_public_path__ + "public/img/车辆布控.6ce4152d.png";